<div class="read-card-wrapper">
  <img class="image" src="assets/img/place_card.png" alt="creditcard"/>
  <p class="card-read-error" *ngIf="cardReadError">Card reader could not read Your card properly, please swipe again</p>
<!--  TODO translate error message-->
</div>
